import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import "./course-consent.page.scss";
import PLButton from "../../components/common/button";
import courseComander from "../../store/commanders/course.comander";
import navigationService from "../../services/navigation/navigation.service";

const CourseConsentPage = () => {
  const history = useHistory();
  const userData = useSelector((state: any) => state.account.userData);
  const course = useSelector((state: any) => state.course);
  const [acceptedLiabilityNotice, setAcceptedLiabilityNotice] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const canAccessCourse = useMemo(() => {
    return !!userData?.valid_subscription || userData?.state === "AL";
  }, [userData?.state, userData?.valid_subscription]);

  useEffect(() => {
    if (!course?.data) {
      courseComander.cmd_get_course();
    }
  }, [course?.data]);

  useEffect(() => {
    if (!canAccessCourse) {
      navigationService.navigate("/payment?product=course");
      return;
    }

    if (course?.data?.courseConsentAccepted) {
      history.replace("/course");
    }
  }, [canAccessCourse, course?.data?.courseConsentAccepted, history]);

  const onContinue = async () => {
    setSubmitting(true);

    try {
      await courseComander.cmd_accept_course_consent();
      history.replace("/course");
    } finally {
      setSubmitting(false);
    }
  };

  if (!canAccessCourse) {
    return null;
  }

  const isReady = acceptedLiabilityNotice;

  return (
    <div className="course-consent-page">
      <div className="course-consent-card">
        <div className="course-consent-eyebrow">Limitation of Liability</div>
        <h1>Please Review Before Continuing</h1>
        <div className="course-consent-copy">
          <p>
            The information provided on this website is for general
            informational purposes only and is not intended as professional
            medical or fitness advice. It does not create a doctor-patient or
            similar professional relationship. You should not rely solely on
            this information for diagnosis, treatment, injury prevention, or
            fitness planning.
          </p>
          <p>
            Always seek advice from a qualified healthcare provider, licensed
            trainer, or other relevant professional before making decisions
            about your health or fitness. We make no representations or
            warranties of any kind, express or implied, including but not
            limited to warranties of accuracy, completeness, timeliness, or
            fitness for a particular purpose. The content may be subject to
            change without notice.
          </p>
          <p>
            To the fullest extent permitted by applicable law, we disclaim all
            liability for any direct, indirect, incidental, consequential,
            special, or punitive damages, including but not limited to injuries
            arising from your use of this website, its content, and/or any
            linked services. We are not responsible for any errors,
            inaccuracies, or omissions in the content. We do not guarantee that
            the information will be free from errors or that it will meet your
            specific needs.
          </p>
          <p>
            Links to third-party websites are provided for convenience only. We
            are not responsible for the content, accuracy, or practices of any
            such sites. You assume all risks associated with your use of this
            website and any advice or training information provided.
          </p>
          <p>
            By using this site, you acknowledge that you have read,
            understood, and agreed to these limitations. This limitation of
            liability shall be governed by the laws of the State of Alabama,
            USA, without regard to its conflict of laws principles.
          </p>
        </div>

        <div className="course-consent-options">
          <label className="course-consent-option">
            <input
              type="checkbox"
              checked={acceptedLiabilityNotice}
              onChange={(event) =>
                setAcceptedLiabilityNotice(event.target.checked)
              }
            />
            <span>
              I acknowledge that I have read, understood, and agreed to these
              limitations of liability.
            </span>
          </label>
        </div>

        <div className="course-consent-actions">
          <PLButton
            variant="primary"
            size="lg"
            onClick={onContinue}
            disabled={!isReady || submitting}
          >
            {submitting ? "Saving..." : "Continue to Course"}
          </PLButton>
        </div>
      </div>
    </div>
  );
};

export default CourseConsentPage;
